import _styled from "styled-components";
import React from "react";
import { ReactComponent as HomeIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/athome.svg";
import { ReactComponent as AwayIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/briefcase.svg";
import { ReactComponent as VacationIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/airplane.svg";

var Container = _styled.div.withConfig({
  displayName: "TemperatureMode__Container",
  componentId: "vtmb3b-0"
})(["display:flex;justify-content:center;margin-top:38px;svg{display:block;width:40px;height:40px;}@media screen and (max-width:419px){margin-top:20px;svg{width:32px;height:32px;}}"]);

var sizeIconPlace = 38;
export function TemperatureMode(_ref) {
  var heatMode = _ref.heatMode;

  if (heatMode === "VACATION") {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(VacationIcon, {
      fill: "white",
      width: sizeIconPlace,
      height: sizeIconPlace
    }));
  }

  if (heatMode === "HOME") {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(HomeIcon, {
      fill: "white",
      width: sizeIconPlace,
      height: sizeIconPlace
    }));
  }

  if (heatMode === "AWAY") {
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(AwayIcon, {
      fill: "white",
      width: sizeIconPlace,
      height: sizeIconPlace
    }));
  }

  return null;
}
export default TemperatureMode;